import 'core-js'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropType from 'prop-types'
import { Router, Route } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import PartnerHeader from 'tfs.partner-header'

import '../../static/scss/index.scss'

import Loading from '../../components/Loading/Loading'
import AuthenticateUser from '../../components/AuthenticateUser/AuthenticateUser'

import { msalInstance } from '../../msalClient'
import history from '../../config/history'
import getUrlParams from '../../helpers/getUrlParams'
import navigationData from '../../config/navigationData'
import { requestAirports } from '../../actions/airports'
import { requestContent } from '../../actions/content'
import { queryStringPrefill } from '../../actions/queryStringPrefill'

import Sidebar from '../Sidebar/Sidebar'
import Search from '../Search/Search'
import FlightOffers from '../FlightOffers/FlightOffers'
import Ancillaries from '../Ancillaries/Ancillaries'
import BookerDetails from '../BookerDetails/BookerDetails'
import GroupDetails from '../GroupDetails/GroupDetails'
import Summary from '../Summary/Summary'
import Confirmation from '../Confirmation/Confirmation'

import './App.scss'

class App extends Component {
  state = {
    hasPrefilled: false,
  }
  componentDidMount() {
    this.props.requestAirports()
    this.props.requestContent()
  }

  componentDidUpdate() {
    const { airports, queryStringPrefill, content } = this.props
    const { hasPrefilled } = this.state
    const params = getUrlParams()
    if (
      !Object.keys(params).length ||
      !airports.list.length ||
      hasPrefilled ||
      content.isFetching
    ) {
      return
    }
    this.setState({ hasPrefilled: true })
    queryStringPrefill({
      airports,
      params,
    })
  }

  getContent = pageName => {
    const { labels } = this.props.content

    if (!labels.length) return {}
    return labels.find(content => content.TemplateName === pageName) || {}
  }

  logout = () => {
    sessionStorage.clear()
    msalInstance.logoutRedirect()
  }

  getNavigationDataForUserRole = roles => {
    if (roles.length === 0 || roles.includes('Admin')) {
      return navigationData.links
    }

    const navLinks = []
    const groupOfferLinks = navigationData.links.find(
      navData => navData.key === 'groupoffers'
    )
    const allotmentLinks = navigationData.links.find(
      navData => navData.key === 'allotments_title'
    )

    if (roles.includes('Allotment')) {
      const allotmentManageNavItems = allotmentLinks.subNavigation.filter(
        navItem => navItem.label !== 'buy_allotments'
      )
      navLinks.push({
        ...allotmentLinks,
        subNavigation: allotmentManageNavItems,
      })
    }

    if (roles.includes('GroupOffer')) {
      navLinks.push(groupOfferLinks)
    }

    if (roles.includes('Quotes')) {
      const allotmentBuyNavItems = allotmentLinks.subNavigation.filter(
        navItem => navItem.label === 'buy_allotments'
      )

      if (navLinks.some(navData => navData.key === 'allotments_title')) {
        navLinks
          .find(navData => navData.key === 'allotments_title')
          .subNavigation.unshift(allotmentBuyNavItems[0])
      } else {
        navLinks.push({
          ...allotmentLinks,
          subNavigation: allotmentBuyNavItems,
        })
      }
    }

    return navLinks
  }

  render() {
    const { isFetching } = this.props.content
    const { airports } = this.props
    const activeUser = this.props.user
    const isPartnerAgent = navigationData.links.length > 0

    return (
      <Router history={history}>
        {isFetching ? (
          <Loading backdrop />
        ) : (
          <AuthenticateUser
            isPartnerAgent={isPartnerAgent}
            labels={this.getContent('Login Panel')}
          >
            <div className="app">
              {isPartnerAgent && (
                <PartnerHeader
                  labels={navigationData.labels}
                  navigationLinks={this.getNavigationDataForUserRole(
                    activeUser?.idTokenClaims?.extension_userRoles || []
                  )}
                  homeUrl={navigationData['home-url']}
                  logout={() => this.logout()}
                  username={activeUser?.idTokenClaims?.given_name || ''}
                />
              )}
              <div className="main-wrapper">
                <Sidebar content={this.getContent} />
                <Route
                  path="/"
                  exact
                  render={({ history }) => (
                    <Search
                      airports={airports.list}
                      resetSearch={this.setInitialState}
                      content={this.getContent}
                      history={history}
                    />
                  )}
                />

                <Route
                  exact
                  path="/flight-offers"
                  render={({ history }) => (
                    <FlightOffers
                      airports={airports.list}
                      content={this.getContent}
                      history={history}
                    />
                  )}
                />

                <Route
                  exact
                  path="/ancillaries"
                  render={({ history }) => (
                    <Ancillaries content={this.getContent} history={history} />
                  )}
                />
                <Route
                  exact
                  path="/booker-details"
                  render={({ history }) => (
                    <BookerDetails
                      content={this.getContent}
                      history={history}
                    />
                  )}
                />
                <Route
                  exact
                  path="/group-details"
                  render={({ history }) => (
                    <GroupDetails content={this.getContent} history={history} />
                  )}
                />
                <Route
                  exact
                  path="/summary"
                  render={({ history }) => (
                    <Summary history={history} content={this.getContent} />
                  )}
                />
                <Route
                  exact
                  path="/success"
                  render={({ history }) => (
                    <Confirmation history={history} content={this.getContent} />
                  )}
                />
              </div>
            </div>
          </AuthenticateUser>
        )}
      </Router>
    )
  }
}

App.propTypes = {
  queryStringPrefill: PropType.func,
  requestAirports: PropType.func,
  requestContent: PropType.func,
  airports: PropType.object,
  content: PropType.object,
}

const withMsalAuthentication = Component => {
  return props => {
    const { accounts } = useMsal()

    return <Component user={accounts[0]} {...props} />
  }
}

const mapStateToProps = state => {
  const { airports, content } = state
  return {
    airports,
    content,
  }
}

const mapDispatchToProps = {
  queryStringPrefill,
  requestAirports,
  requestContent,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMsalAuthentication(App))
